// @flow

import * as React from 'react';

import { selectCartIsWorking } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectCurrentBU } from 'src/modules/organization/selectors';

import Price from './Price';

type Props = {
  hasTaxes?: boolean,
  totalPrice: ?number,
  priceCrossedOut?: number,
  hasDiscount?: boolean,
};

export default function TotalRow({
  totalPrice,
  priceCrossedOut,
  hasTaxes,
  hasDiscount,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const currentBU = useAppSelector(selectCurrentBU);
  const cartIsWorking = useAppSelector(selectCartIsWorking);

  return (
    <Base flex flexAlignItemsBaseline gap="xsmall">
      <Base flexExpandLeft tagName="span">
        {__('Price')}
      </Base>
      <Price
        weight="semibold"
        price={cartIsWorking ? undefined : totalPrice}
        hasDiscount={hasDiscount}
        showExcludeVatMention={(hasTaxes && currentBU !== 3) || !hasTaxes}
        priceCrossedOut={priceCrossedOut}
      />
    </Base>
  );
}
